import React from 'react';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import './index.less';

const RuleIconText = () => {
  return (
    <div className="rule-icon-wrapper">
      <div>
        规则直选
        <Tooltip title="通过选择规则标签，直接生成目标素材组（目前仅支持规则直选商品）" placement="right">
          <QuestionCircleOutlined style={{ marginLeft: 4 }} />
        </Tooltip>
      </div>
      <div className="img">
        <img
          src="https://img12.360buyimg.com/imagetools/jfs/t1/184184/12/31371/3813/6385a27bE813f559b/7cebfaba65302460.png"
          alt=""
        />
      </div>
    </div>
  );
};

export default RuleIconText;
